import {
  GET_SCRATCH_MY_TICKETS_REQUEST,
  GET_SCRATCH_MY_TICKETS_SUCCESS,
  GET_SCRATCH_MY_TICKETS_FAILURE,
  RESET_SCRATCH_TICKETS_PAGINATION
} from 'Store/constants';
  
    
const initialState = {
  playedCoupons: {
    coupons: [],
    totalElements: 0,
    totalPages: 0
  },
  pagination: {
    pageIndex: 0,
    pageSize: 10,
    hasMore: null
  },
  isFetched: false,
  isLoading: true,
  error: null
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_SCRATCH_MY_TICKETS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_SCRATCH_MY_TICKETS_SUCCESS:
      return { ...state,
        playedCoupons: {
          coupons: [...state.playedCoupons.coupons, ...action.payload.coupons],
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages
        },
        pagination: { ...action.pagination, hasMore: true },
        isLoading: false, error: null };
    case GET_SCRATCH_MY_TICKETS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_SCRATCH_TICKETS_PAGINATION:
      return initialState;
    default:
      return state;
  }
};